import React from 'react'

const Weekday: React.FC = ({ children }) => (
	<span className="w-full text-center font-semibold bg-gray-600 text-gray-100">
		{children}
	</span>
)

export default Weekday
